/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaPinterest,
  FaInstagram,
} from "react-icons/fa";
import logo from "../assets/logo.svg";

function Footer() {
  return (
    <footer className="bg-dark text-white py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-12 col-md-6 text-center text-md-start mb-3 mb-md-0">
            <img src={logo} alt="Loopstudios Logo" className="h-8" />
          </div>
          <div className="col-12 col-md-6">
            <ul className="nav justify-content-center justify-content-md-end">
              {["About", "Careers", "Events", "Products", "Support"].map(
                (item) => (
                  <li key={item} className="nav-item">
                    <Link
                      to={`/${item.toLowerCase()}`}
                      className="nav-link text-white"
                    >
                      {item}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-12 col-md-6 text-center text-md-start mb-3 mb-md-0">
            <div className="d-flex justify-content-center justify-content-md-start gap-3">
              <a href="#" className="text-white">
                <FaFacebook />
              </a>
              <a href="#" className="text-white">
                <FaTwitter />
              </a>
              <a href="#" className="text-white">
                <FaPinterest />
              </a>
              <a href="#" className="text-white">
                <FaInstagram />
              </a>
            </div>
          </div>
          <div className="col-12 col-md-6 text-center text-md-end">
            <p>© 2025 LOOPSTUDIOS . ALL RIGHTS RESERVED . &copy;AHMED EHAB .</p>
            <span></span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
